// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1pW6M","name":"Header_name__RRmMA","birthday":"Header_birthday__2B07N","skeleton":"Header_skeleton__12l4Q"};